import React, { useState } from 'react';
import '../styles/components.css';

const GuessInput = ({ onSubmit, isActive }) => {
    const [guess, setGuess] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!guess.trim()) {
            setError('Please enter a guess');
            return;
        }

        if (!isActive) {
            setError('Waiting for game to start');
            return;
        }

        try {
            await onSubmit(guess.trim());
            setGuess('');
            setError('');
        } catch (err) {
            setError(err.message || 'Failed to submit guess');
        }
    };

    return (
        <div className="guess-input-wrapper">
            <form onSubmit={handleSubmit} className="prompt-input-container">
                <input
                    type="text"
                    placeholder="What do you think this is?"
                    value={guess}
                    onChange={(e) => setGuess(e.target.value)}
                    className={`prompt-input ${error ? 'error' : ''}`}
                    disabled={!isActive}
                />
                <button
                    type="submit"
                    className="primary-button"
                    disabled={!guess.trim() || !isActive}
                >
                    Submit Guess
                </button>
            </form>
            {error && <div className="error-message">{error}</div>}
        </div>
    );
};

export default GuessInput; 